import { type PropsWithChildren } from 'react'
import { useTheme } from '@dhl-ui/theme'
import { Box } from '../Box'

export type IconSeverityProps = PropsWithChildren<{
  severity?: 'success' | 'info' | 'warning' | 'error'

  isBlock?: boolean

  /**
   * When you need a block but not in square you can alternatively make it rounded
   * not meant to be used inside a ListItem but for example in a Blaze or Card
   * @default false
   */
  isRounded?: boolean
}>

/**
 * We can show an Icon with a specific severity inside a ListItem or Card for example
 */
export const IconSeverity = ({ children, severity, isBlock, isRounded }: IconSeverityProps) => {
  const { palette } = useTheme()

  const color = !severity ? 'inherit' : palette[severity].dark
  const backgroundColor = !severity ? 'grey.200' : palette[severity].light

  return (
    <Box
      sx={{
        display: 'inline-block',
        ...(isBlock ? { p: 1, borderRadius: isRounded ? '50%' : 1, backgroundColor, lineHeight: 0 } : {}),
        color,
      }}
    >
      {children}
    </Box>
  )
}
